import React from 'react';
import { useNavigate } from 'react-router-dom';

const ErroApp = ({ mensagem }) => {
  const navigate = useNavigate();
  return (
    <>
      <div className="m">
        <h2>Erro do App</h2>
        <div>{mensagem || 'Erro do App'}</div>
        <div className="botoes" style={{ justifyContent: 'left' }}>
          <button onClick={() => navigate(-1)}>Voltar</button>
        </div>
      </div>
    </>
  );
};

export default ErroApp;
